import { render } from "./CashierInsuranceClaims.vue?vue&type=template&id=152a301d"
import script from "./CashierInsuranceClaims.vue?vue&type=script&lang=js"
export * from "./CashierInsuranceClaims.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__